interface IHomeAwayType {
  label: string;
  shortLabel: string;
  key: number;
}

enum HomeAwayType {
  Home = 0,
  Away = 1,
  Neutral = 2
}

export default HomeAwayType;

export const HOME_AWAY_TYPE_CONFIG: Map<HomeAwayType, IHomeAwayType> = new Map([
  [
    HomeAwayType.Home,
    {
      label: HomeAwayType[HomeAwayType.Home],
      shortLabel: 'vs',
      key: HomeAwayType.Home
    }
  ],
  [
    HomeAwayType.Away,
    {
      label: HomeAwayType[HomeAwayType.Away],
      shortLabel: '@',
      key: HomeAwayType.Away
    }
  ],
  [
    HomeAwayType.Neutral,
    {
      label: HomeAwayType[HomeAwayType.Neutral],
      shortLabel: '@',
      key: HomeAwayType.Neutral
    }
  ]
]);

export const HOME_AWAY_TYPE_CONFIG_VALUES = Array.from(
  HOME_AWAY_TYPE_CONFIG.values()
);
